// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__qVVMc","card":"card__Uv5sN","container":"container__M4TP+","title-main":"title-main__gQL4s","titleMain":"title-main__gQL4s"};